export enum TIMING_NAME {
  ABTEST = 'ABTEST',
  ABTEST_LOGIN = 'ABTEST_LOGIN',
  AUTHENTICATED_SESSION = 'AUTHENTICATED_SESSION',
  BRAND = 'BRAND',
  BUSINESS_PROFILES = 'BUSINESS_PROFILES',
  CASPER = 'CASPER',
  CASPER_DATA = 'CASPER_DATA',
  CLIENT_DOM_INTERACTIVE = 'CLIENT_DOM_INTERACTIVE',
  CLIENT_FE = 'CLIENT_FE',
  CLIENT_REQUEST_START = 'CLIENT_REQUEST_START',
  CLIENT_RESPONSE_END = 'CLIENT_RESPONSE_END',
  CLIENT_RESPONSE_START = 'CLIENT_RESPONSE_START',
  COMMON_DATA = 'COMMON_DATA',
  CONFIG = 'CONFIG',
  CONFIG_VALUES = 'CONFIG_VALUES',
  CREATE_COMMON_DATA = 'CREATE_COMMON_DATA',
  CREATE_PAGE_WRAPPER_DATA = 'CREATE_PAGE_WRAPPER_DATA',
  CREATE_SEARCH_DEFAULT_DATA = 'CREATE_SEARCH_DEFAULT_DATA',
  CREATE_SEARCH_PAGE_DATA = 'CREATE_SEARCH_PAGE_DATA',
  DEFAULT_BP = 'DEFAULT_BP',
  DEFAULT_DEST = 'DEFAULT_DEST',
  DEFAULT_VALUES = 'DEFAULT_VALUES',
  DOMAINS = 'DOMAINS',
  EMISSIONS_HOTEL_TYPES = 'EMISSIONS_HOTEL_TYPES',
  GET_BRAND_VALUES = 'GET_BRAND_VALUES',
  GET_CONTENT_HUB_FOOTER_PROPS = 'GET_CONTENT_HUB_FOOTER_PROPS',
  GET_CONTENT_HUB_HEADER_PROPS = 'GET_CONTENT_HUB_HEADER_PROPS',
  GET_DOMAIN_VALUES = 'GET_DOMAIN_VALUES',
  GET_PRODUCTS = 'GET_PRODUCTS',
  IMAGES_HOTELS = 'IMAGES_HOTELS',
  LAT_LON = 'LAT_LON',
  LOCALIZATION = 'LOCALIZATION',
  LOGIN = 'LOGIN',
  MEMORY_CACHE = 'MEMORY_CACHE',
  PAGE_WRAPPER_SERVER_SEARCH = 'PAGE_WRAPPER_SERVER_SEARCH',
  PAGE_WRAPPER_SERVER_DETAILS = 'PAGE_WRAPPER_SERVER_DETAILS',
  PAGE_WRAPPER_SERVER_PROMISE_ALL = 'PAGE_WRAPPER_SERVER_PROMISE_ALL',
  POPULATE_CACHE = 'POPULATE_CACHE',
  RESOLVE_BP = 'RESOLVE_BP',
  SEARCH_INFO_DATA = 'SEARCH_INFO_DATA',
  SEARCH_INFO_DETAIL_DATA = 'SEARCH_INFO_DETAIL_DATA',
  SEARCH_PERIMETERS = 'SEARCH_PERIMETERS',
  SERVER_DEBUG_DATA = 'SERVER_DEBUG_DATA',
  SERVER_SIDE = 'SERVER_SIDE',
  STATIC_DATA = 'STATIC_DATA',
  TRANSLATIONS = 'TRANSLATIONS',
}
